import React from 'react'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { useSelector, shallowEqual } from 'dva'
import { Link } from 'react-router-dom'
import './index.less'
import classNames from 'classnames'

type Props = {
  /**是否是以button形式去展示 */
  isButton?: boolean
  isSticky?: boolean
}

const selector = ({ home, loading }) => ({
  categoryList: home.categoryList || [],
  loading: loading.effects['home/homepageQuery'],
})

const CategoryPicker = ({ isButton, isSticky }: Props) => {
  const { categoryList } = useSelector(selector, shallowEqual)

  return (
    <div
      className={classNames(
        'category-picker',
        isButton && 'category-picker-button'
      )}
    >
      <div className="category-picker-title">
        <span>商品分类</span>
        <DownOutlined className="category-picker-down" />
        <UpOutlined className="category-picker-up" />
      </div>
      <div className="category-picker-cont">
        {categoryList?.map(category => (
          <div key={category.productCode} className="category-picker-item">
            <Link
              className="picker-item-title"
              to={`/search?c=${category.productCode}&page=1&sort=0`}
            >
              {category.product}
            </Link>
            {!!category.childList.length && (
              <PickerItemMore data={category.childList} />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default React.memo(CategoryPicker)

interface PickerItemMoreProps {
  data?: Array<SwaggerDTO.ProductConfigSpuInfoDTO>
}

const PickerItemMore = ({ data }: PickerItemMoreProps) => {
  return (
    <div className="picker-item-more">
      {data?.map(item => (
        <div key={item.productCode} className="item-more-item">
          <Link
            to={`/search?c=${item.productCode}&page=1&sort=0`}
            className="more-item-title"
          >
            {item.product}
          </Link>
          <div className="more-item-list">
            {item?.childList?.map((child, index) => (
              <React.Fragment key={child.productCode}>
                <Link
                  to={`/search?c=${child.productCode}&page=1&sort=0&type=app`}
                  className="more-item-list-text"
                >
                  {child.product}
                </Link>
                {index + 1 !== item?.childList?.length && (
                  <span className="more-item-list-line" />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
